import React from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

const MarkdownRenderer = ({ content, emptyLabel = "Pas d'information" }) => {
  if (!content?.trim()) {
    return <span className="text-muted fst-italic">{emptyLabel}</span>;
  }

  return (
    <div className="markdown-content">
      <ReactMarkdown remarkPlugins={[remarkBreaks]}>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
